module.exports = __webpack_public_path__ + "img/basculante.7a467a3.svg";